module.exports = __webpack_public_path__ + "media/images/plans/e-photo_location/e-photo_location-2-369271f1fe34c45e0600a6b882ffd16c.png";